/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Too_Many_Files_SelectedInputs */

const en_toast_too_many_files_selected = /** @type {(inputs: Toast_Too_Many_Files_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many files selected. Only 1 file is allowed.`)
};

const nl_toast_too_many_files_selected = /** @type {(inputs: Toast_Too_Many_Files_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te veel bestanden geselecteerd! Slechts 1 is toegestaan.`)
};

/**
* | output |
* | --- |
* | "Too many files selected. Only 1 file is allowed." |
*
* @param {Toast_Too_Many_Files_SelectedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_too_many_files_selected = /** @type {((inputs?: Toast_Too_Many_Files_SelectedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Too_Many_Files_SelectedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_too_many_files_selected(inputs)
	return en_toast_too_many_files_selected(inputs)
});